module.exports = __webpack_public_path__ + "img/79.10.pH.e90994d0.png";